module.exports = __webpack_public_path__ + "img/app-store.db014b1c.svg";